import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Login from './pages/login'
import ProtectedRoute from './components/protectedRoute';
import './App.css'
import { useEffect, useState } from 'react'
import OAuthCallback from './services/authCallback';
import SilentCallback from './services/silentCallback';
import { getUser } from './services/authService';
import NavBar from './components/NavBar';
import HomePage from './pages/HomePage';
import ActivitiesPage from './pages/ActivitiesPage';
import Products from './pages/Products';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Help from './pages/Help';
import UsersManagement from './pages/UsersManagement';
import UserProfile from './pages/UserProfile';
import CreateUser from './pages/CreateUser';
import SkillsManagement from './pages/SkillsManagement';
import ActivityManagement from './pages/ActivityManagement';
import MyActivities from './pages/MyActivities';
import CvManagement from './pages/CvManagement';
import LocationReporter from './components/LocationReporter';
import { initializeLinkContextMenu } from './utils/linkContextMenu';
import { PLATFORM_URL } from './config/constants';

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [email, setEmail] = useState('');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ Add loading state

  async function fetchData() {
    const user = await getUser();
    if (!user || !user.profile) {
      setEmail('');
      setUser(null); 
      setLoggedIn(false);
    } else {
      const accessToken = user.access_token;
      setEmail(user.profile.email);
      setUser(user); 
      setLoggedIn(true);
    }
    setLoading(false); // ✅ Set loading to false after fetch
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!loggedIn || !user) {
      return;
    }

    let linkContextMenuInstance = null;
    
    const initializeMenu = () => {
      linkContextMenuInstance = initializeLinkContextMenu({
        debug: true,
        excludeClasses: ['no-context-menu', 'exclude-context', 'no-right-click', 'exclude-menu'],
        excludeAttributes: {
          'data-exclude-menu': 'true',
          'data-no-context': 'true',
          'data-exclude-context': 'true'
        },
        excludeSelectors: ['.no-context-menu', '.exclude-context', '.no-right-click'],
        // Add any extra actions beyond the default two
        // extraActions: [
        //   { text: 'Copy Link', action: 'copyLink' },
        //   // { text: 'Share Link', action: 'shareLink' }
        // ],        
        // onCopyLink: function(url, linkElement, event) {
        //   console.log('LINK WAS COPIED');
        // },
        instanceId: user.profile?.subscriptionId || 'default-instance',
        widgetId: 'evo-adoption-client.native-tab',
        platformUrl: PLATFORM_URL
      });
    };
    
    initializeMenu();
    
    return () => {
      if (linkContextMenuInstance && linkContextMenuInstance.destroy) {
        linkContextMenuInstance.destroy();
      }
    };
  }, [loggedIn, user]);

  if (loading) return <div>Loading...</div>; // ✅ Prevent premature redirect

  return (
    <div className="App">
      <BrowserRouter>
        {loggedIn && <NavBar loggedIn={loggedIn} />}
       <LocationReporter /> 
        <Routes>
          <Route path="/" element={<Login loggedIn={loggedIn} />} />
          <Route path="/login" element={<Login loggedIn={loggedIn} />} />
          <Route path='/oidc/client' element={<OAuthCallback setLoggedIn={setLoggedIn} />} />
          <Route path='/oidc/silent' element={<SilentCallback />} />
          <Route path="/homepage" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <HomePage email={email} loggedIn={loggedIn} setLoggedIn={setLoggedIn} user={user} />
            </ProtectedRoute>
          } />
          <Route path="/activities" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <ActivitiesPage user={user} />
            </ProtectedRoute>
          } />
          <Route path="/products" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <Products />
            </ProtectedRoute>
          } />
          <Route path="/services" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <Services />
            </ProtectedRoute>
          } />
          <Route path="/about" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <About />
            </ProtectedRoute>
          } />
          <Route path="/contact" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <Contact />
            </ProtectedRoute>
          } />
          <Route path="/help" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <Help />
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <UsersManagement user={user} />
            </ProtectedRoute>
          } />
          <Route path="/users/new" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <CreateUser user={user} />
            </ProtectedRoute>
          } />
          <Route path="/users/:id" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <UserProfile currentUser={user} />
            </ProtectedRoute>
          } />
          <Route path="/skills" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <SkillsManagement user={user} />
            </ProtectedRoute>
          } />
          <Route path="/activities/manage" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <ActivityManagement user={user} />
            </ProtectedRoute>
          } />
          <Route path="/activities/my" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <MyActivities user={user} />
            </ProtectedRoute>
          } />
          <Route path="/cvs" element={
            <ProtectedRoute authenticated={loggedIn} redirectPath='/'>
              <CvManagement currentUser={user} />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  )
}
export default App
